import styles from "./index.module.scss";
import { 
  Generating,
  MainOperation,
  RemoveTip,
  RecommendPanel,
  AllPresetPanel,
  SwapPanel,
  CustomTempUpload,
  ResultPanel,
  Failed,
  GlobalLoading,
  ReuploadModal,
  VideoPlaceholder,
} from "@/components";
import { useCommonStore } from "@/stores";

const Main = () => {
  const generating = useCommonStore(state => state.generating);
  const removeTipVisible = useCommonStore(state => state.removeTipVisible);
  const activeTemp = useCommonStore(state => state.activeTemp);
  const allPresetVisible = useCommonStore(state => state.allPresetVisible);
  const isFailed = useCommonStore(state => state.getters.isFailed);
  const reuploadOption = useCommonStore(state => state.reuploadOption);
  
  return (
    <main
      className={styles["main"]}
    >
      <div
        className={styles["left_area"]}
      >
        {removeTipVisible && (
          <RemoveTip></RemoveTip>
        )}

        {activeTemp ? (
          <>
            {isFailed ? (
              <Failed></Failed>
            ) : (
              <ResultPanel></ResultPanel>
            )}
          </>
        ) : (
          <div
            className={styles["upload_wrap"]}
          >
            <VideoPlaceholder></VideoPlaceholder>

            <CustomTempUpload></CustomTempUpload>
          </div>
        )}

        {generating && (
          <Generating></Generating>
        )}

        <MainOperation></MainOperation>
      </div>

      <div
        className={styles["right_area"]}
      >
        {activeTemp ? (
          <SwapPanel></SwapPanel>
        ) : (
          <>
            {allPresetVisible ? (
              <AllPresetPanel></AllPresetPanel>
            ) : (
              <RecommendPanel></RecommendPanel>
            )}
          </>
        )}
      </div>

      <GlobalLoading></GlobalLoading>

      {reuploadOption.show && (
        <ReuploadModal></ReuploadModal>
      )}
    </main>
  )
}

export default Main;